<template>
  <div>
    <v-card>
      <v-card-title>Usage Details</v-card-title>
      <v-card-text>
        <div class="ck-editor">
          <div class="history-data-parent">
            <span>
              <v-data-table
                :headers="headers"
                :items="data.question.history_details"
                class="elevation-1"
                :hide-default-footer="true"
                :mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left fix-101">
                      {{ item.test_name }}
                    </td>
                    <td class="text-left fix-101">
                      {{ item.created_at }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "HistoryDetails",
  props: ["data", "onClose"],
  data() {
    return {
      headers: [
        {
          text: "Test Name",
          align: "left",
          value: "date",
          sortable: false,
        },
        { text: "Created On", align: "left", value: "center",sortable: false, },
      ],
    };
  },
  methods: {},
};
</script>
